import { ReactComponent as EcommerceSVG } from '@/assets/icons/navbar/ic_ecommerce.svg';
import { MakersForm } from '@/components/makers/modals/MakersForm';
import {
  selectMakersStoreSelectedRow,
  useMakersStore,
  useMakersStoreActions,
  useMakersStoreContextWindowsState,
} from '@/components/makers/useMakersStore';
import { Modal, ModalBreadcrumbs, ModalHeader, ModalTabbar } from '@/components/Modal';

// ----------------------------------------------------------------------

export const MakersEditModal = () => {
  const maker = useMakersStore(selectMakersStoreSelectedRow);

  const { isEditModalVisible } = useMakersStoreContextWindowsState();
  const { closeEditModal } = useMakersStoreActions();

  return (
    <Modal open={isEditModalVisible} onClose={closeEditModal}>
      <ModalHeader onClose={closeEditModal}>
        <ModalBreadcrumbs
          rootIcon={<EcommerceSVG />}
          breadcrumbs={[{ name: 'Производители' }, { name: maker?.name ?? '' }]}
        />
      </ModalHeader>

      <ModalTabbar value="general" tabs={[{ label: 'Основная информация', value: 'general' }]} />

      <MakersForm variant="edit" maker={maker} onClose={closeEditModal} />
    </Modal>
  );
};
